import { Box, Button, Typography, useTheme } from "@mui/material";
import React from "react";
import HamMenuIcon from "../../../../media/images/icons/hambergerMenu";
import NotifsIcon from "../../../../media/images/icons/notification-bing";
import { useAppDispatch } from "../../../../hooks/useRedux";
import { setOpenAuthSidebar } from "../../../../redux/features/settingSlice";
import { useNavigate } from "react-router-dom";

export default function Header() {
  const theme = useTheme();

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        // border: "1px solid gray",
        padding: "8px 16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <Button
        onClick={() => dispatch(setOpenAuthSidebar(true))}
        sx={{
          display: "flex",
          alignItems: "center",
          border: "1px solid gray",
          gap: "8px",
          borderColor: `${theme.palette.secondary.main} !important`,
          backgroundColor: `${theme.palette.secondary.light} !important`,
          "& .MuiTouchRipple-root": {
            color: `${theme.palette.secondary.main} !important`,
            borderWidth: "0px !important",
          },
          "& .MuiButtonBase-root": {
            color: `${theme.palette.secondary.main} !important`,
            borderWidth: "0px !important",
          },
        }}
      >
        <HamMenuIcon color={theme.palette.secondary.dark} />
        <Typography
          sx={{
            color: "secondary.main",
            fontWeight: 600,
          }}
        >
          منو
        </Typography>
      </Button>
      <Button
        onClick={() => navigate("/notifs")}
        sx={{
          display: "flex",
          alignItems: "center",
          border: "1px solid gray",
          gap: "8px",
          borderColor: `${theme.palette.secondary.main} !important`,
          backgroundColor: `${theme.palette.secondary.light} !important`,
          "& .MuiTouchRipple-root": {
            color: `${theme.palette.secondary.main} !important`,
            borderWidth: "0px !important",
          },
          "& .MuiButtonBase-root": {
            color: `${theme.palette.secondary.main} !important`,
            borderWidth: "0px !important",
          },
        }}
      >
        <Typography
          sx={{
            color: "secondary.main",
            fontWeight: 600,
          }}
        >
          اعلان‌ها
        </Typography>
        <NotifsIcon color={theme.palette.secondary.dark} />
      </Button>
    </Box>
  );
}
